import React from 'react';
import { useField } from 'formik';
import { IFormikFieldProps } from './FormikFieldProps';
import { HtmlEditor as HtmlEditorComponent } from '../form/htmlEditor/HtmlEditor';

export type HTMLEditorProps = IFormikFieldProps;

export const HtmlEditor: React.FC<HTMLEditorProps> = (props) => {
  const [field, { error }, { setValue }] = useField(props);

  return (
    <HtmlEditorComponent {...field} isInvalid={!!error} onChange={setValue} />
  );
};
